import React from "react";
import CustomModalV1 from "components/custom-modal/CustomModalV1";
import ButtonV1 from "components/button/Button";
import { AlertCircleIconV1 } from "images/image-component";
import "./error-modal.css";

interface Props {
  isOpen: boolean;
  errorMsg: string;
  handleClose: () => void;
  tryAgain?: () => void;
}

function ErrorModal({ isOpen, handleClose, tryAgain, errorMsg }: Props) {
  return (
    <CustomModalV1 isOpen={isOpen} handleClose={handleClose}>
      <div className="v1-error-modal">

        <div className="v1-error-icon">
          <AlertCircleIconV1 />
        </div>

        <h3 className="v1-error-title">Something went wrong</h3>
        <p className="v1-error-msg">{errorMsg}</p>

        <div className="v1-error-actions">
          {tryAgain && (
            <ButtonV1 variant="ghost" onClick={tryAgain}>
              Try again
            </ButtonV1>
          )}
          <ButtonV1 variant="subtle" onClick={handleClose}>
            Close
          </ButtonV1>
        </div>

      </div>
    </CustomModalV1>
  );
}

export default ErrorModal;
